import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  Inject,
  Input,
} from '@angular/core';
import {WINDOW} from '@ng-web-apis/common';

@Directive({
  selector: '[imageLazyLoad]',
  standalone: false,
})
export class ImageLazyLoadDirective implements AfterViewInit {
  @Input() srcData = '';

  @HostBinding('attr.src') srcAttr: string | null = null;

  constructor(
    @Inject(WINDOW) readonly window: Window,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    if (this._canLazyLoad()) {
      if (!this._hasLazyLoadAttribute()) {
        this.elementRef.nativeElement.setAttribute('loading', 'lazy');
      }
      this._loadImage();

      return;
    }

    if (this._canIntersectionObserver()) {
      this._loadImageWithIntersectionObserver();
    } else {
      this._loadImage();
    }
  }

  private _hasLazyLoadAttribute() {
    return this.elementRef.nativeElement.getAttribute('loading') === 'lazy';
  }

  private _canIntersectionObserver() {
    return 'IntersectionObserver' in this.window;
  }

  private _canLazyLoad() {
    return 'loading' in HTMLImageElement.prototype;
  }

  private _loadImage() {
    this.srcAttr = this.srcData;
  }

  private _loadImageWithIntersectionObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._loadImage();
          this.cdr.markForCheck();
          observer.disconnect();
        }
      });
    }, {});

    observer.observe(this.elementRef.nativeElement);
  }
}
